(function () {
  if (customElements.get("croma-vertical-collections")) {
    return;
  }

  class CromaVerticalCollections extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector("[data-vertical-collections-list]");
      this.triggers = Array.from(this.querySelectorAll("[data-vertical-collections-trigger]"));
      this.mediaItems = Array.from(this.querySelectorAll("[data-vertical-collections-media]"));
      this.defaultIndex = this.triggers.findIndex((trigger) => trigger.classList.contains("is-active"));
      this.activeIndex = this.defaultIndex;
      this.mobileQuery = window.matchMedia("(max-width: 749px)");
      this.reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.rotationDelay = 5000;
      this.rotationTimer = null;
      this.onTriggerEnter = (event) => this.activate(event.currentTarget.dataset.verticalCollectionsIndex);
      this.onListLeave = () => this.activate(this.defaultIndex);
      this.onMediaChange = () => this.updateAutoRotation();
      this.onVisibilityChange = () => this.updateAutoRotation();
      this.onFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) {
          this.activate(this.defaultIndex);
        }
      };
    }

    connectedCallback() {
      if (this.defaultIndex < 0) {
        this.defaultIndex = 0;
      }

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("mouseenter", this.onTriggerEnter);
        trigger.addEventListener("focus", this.onTriggerEnter);
      });

      this.list?.addEventListener("mouseleave", this.onListLeave);
      this.addEventListener("focusout", this.onFocusOut);
      this.activate(this.defaultIndex);
      this.mobileQuery.addEventListener("change", this.onMediaChange);
      this.reducedMotionQuery.addEventListener("change", this.onMediaChange);
      document.addEventListener("visibilitychange", this.onVisibilityChange);
      this.updateAutoRotation();
    }

    disconnectedCallback() {
      this.triggers.forEach((trigger) => {
        trigger.removeEventListener("mouseenter", this.onTriggerEnter);
        trigger.removeEventListener("focus", this.onTriggerEnter);
      });

      this.list?.removeEventListener("mouseleave", this.onListLeave);
      this.removeEventListener("focusout", this.onFocusOut);
      this.mobileQuery.removeEventListener("change", this.onMediaChange);
      this.reducedMotionQuery.removeEventListener("change", this.onMediaChange);
      document.removeEventListener("visibilitychange", this.onVisibilityChange);
      this.stopAutoRotation();
    }

    activate(index) {
      const activeIndex = String(index ?? 0);
      this.activeIndex = Number(activeIndex);

      this.triggers.forEach((trigger) => {
        trigger.classList.toggle("is-active", trigger.dataset.verticalCollectionsIndex === activeIndex);
      });

      this.mediaItems.forEach((media) => {
        const isActive = media.dataset.verticalCollectionsIndex === activeIndex;

        media.classList.toggle("is-active", isActive);
        media.setAttribute("aria-hidden", isActive ? "false" : "true");
      });
    }

    updateAutoRotation() {
      this.stopAutoRotation();

      if (
        !this.mobileQuery.matches ||
        this.reducedMotionQuery.matches ||
        document.hidden ||
        this.triggers.length < 2
      ) {
        return;
      }

      this.rotationTimer = window.setInterval(() => {
        this.activate((this.activeIndex + 1) % this.triggers.length);
      }, this.rotationDelay);
    }

    stopAutoRotation() {
      if (!this.rotationTimer) {
        return;
      }

      window.clearInterval(this.rotationTimer);
      this.rotationTimer = null;
    }
  }

  customElements.define("croma-vertical-collections", CromaVerticalCollections);
})();
